// extracted by mini-css-extract-plugin
export default {"container":"hZrK","photo":"XzXe","imgWrapper":"zzfM","btnsWrapper":"ctFG"};